module.exports = __webpack_public_path__ + "img/south-korea.905fcb9b.png";